import { render, staticRenderFns } from "./NotificationGroupAdministration.vue?vue&type=template&id=4a49b28c&"
import script from "./NotificationGroupAdministration.vue?vue&type=script&lang=js&"
export * from "./NotificationGroupAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports